<ion-header slot="fixed">
  <ion-toolbar>
      <ion-title mode="ios" role="heading" class="transit-detail-header">{{ prompt }}</ion-title>
  </ion-toolbar>
  <ion-toolbar>
      <ion-searchbar (ionInput)="filterList($event)" [placeholder]="searchPlaceholder" ></ion-searchbar>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-list>
      <ion-item size='cover' *ngFor="let item of items; let index = index" (click)="onClickRadio(item)" attr.last={{lastItem(index)}} >
        <div tabindex="0"></div>
        <ion-label [innerHTML]="item.text"></ion-label>
      </ion-item>
  </ion-list>
</ion-content>
